import React from "react";
import { MdClose } from "react-icons/md";
import classes from "./Search.module.scss";
import { useTheme } from "../../hooks/useTheme";

type Props = {
  onChange: (value: string) => void;
  clear: () => void;
  placeHolder?: string;
  value: string;
};

const Search = ({ onChange, clear, placeHolder, value }: Props) => {
  const { isDark } = useTheme();

  return (
    <div className={classes.container}>
      <input
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        value={value}
        className={`${classes.input} ${isDark ? classes.inputDark : ""}`}
        placeholder={placeHolder ? placeHolder : "Введите текст для поиска"}
      />
      {value.length > 0 && (
        <div className={classes.clearAnchor} onClick={clear}>
          <MdClose size={20} className={classes.icon} />
        </div>
      )}
    </div>
  );
};

export default Search;